// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-header {
  height: 10vw;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
ion-header ion-title {
  padding: 2px;
  font-size: 20px;
  font-weight: 500;
  color: var(--ion-color-primary);
  position: relative;
  top: 0;
}
ion-header ion-icon.close-button {
  margin: 2vw;
  position: relative;
  border: 1px solid;
  border-radius: 10px;
  height: 5vw;
  width: 8vw;
  color: var(--ion-color-primary);
}

:host {
  background: var(--ion-ultra-grey);
  --background: var(--ion-ultra-grey);
}

ion-card {
  box-shadow: none;
}
ion-card ion-label {
  font-size: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
ion-card form {
  margin: 16px;
}
ion-card form ion-textarea {
  --padding-start: 10px;
  border-radius: 15px;
  border: 0px solid var(--ion-color-tertiary);
  width: 100%;
  box-shadow: var(--shadow-l1);
  background: var(--ion-ultra-grey);
  --background: var(--ion-ultra-grey);
}
ion-card form ion-card.upload {
  padding: 10px;
  margin: 10px 0;
  border-radius: 15px;
  border: 0px solid var(--ion-color-tertiary);
  text-align: center;
  box-shadow: var(--shadow-l);
  width: 100%;
  background: var(--ion-ultra-grey);
  --background: var(--ion-ultra-grey);
}
ion-card form ion-card.upload ion-label ion-icon {
  font-size: 35px;
}
ion-card form ion-card.upload ion-label p {
  font-size: 15px;
  font-weight: 600;
  line-height: 23px;
  letter-spacing: 0em;
  color: var(--ion-color-primary);
}
ion-card form ion-card.upload ion-label small {
  font-size: 9px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0em;
  color: var(--ion-white-primary);
}
ion-card form ion-button {
  height: 10vw;
  --border-radius: 12px;
  width: 100%;
  font-size: 18px;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0em;
  text-align: left;
  margin-top: 30px;
  --background: var(--ion-color-primary);
  --background-activated: var(--ion-color-primary);
  --background-focused: var(--ion-color-primary);
  --background-hover: var(--ion-color-primary);
}

.hideThis {
  visibility: hidden;
  position: fixed;
}`, "",{"version":3,"sources":["webpack://./src/app/community/comment-modal/comment-modal.page.scss"],"names":[],"mappings":"AAAA;EACC,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AACD;AACC;EACC,YAAA;EACA,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,kBAAA;EACA,MAAA;AACF;AAEC;EACC,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,UAAA;EACA,+BAAA;AAAF;;AAIA;EACC,iCAAA;EACG,mCAAA;AADJ;;AAIC;EAEC,gBAAA;AAFF;AAIE;EACC,eAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AAFH;AAKE;EACC,YAAA;AAHH;AAKG;EACC,qBAAA;EACA,mBAAA;EACA,2CAAA;EACA,WAAA;EACA,4BAAA;EACA,iCAAA;EACA,mCAAA;AAHJ;AAKG;EACF,aAAA;EACG,cAAA;EACA,mBAAA;EACA,2CAAA;EACA,kBAAA;EACA,2BAAA;EACA,WAAA;EACH,iCAAA;EACG,mCAAA;AAHJ;AAMK;EACC,eAAA;AAJN;AAOK;EACC,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,+BAAA;AALN;AAQK;EACC,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,+BAAA;AANN;AAUG;EACC,YAAA;EACA,qBAAA;EACA,WAAA;EAEA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,sCAAA;EACA,gDAAA;EACA,8CAAA;EACA,4CAAA;AATJ;;AAcA;EACC,kBAAA;EACA,eAAA;AAXD","sourcesContent":["ion-header {\n\theight: 10vw;\n\tdisplay: flex;\n\tflex-direction: row;\n\tjustify-content: center;\n\talign-items: center;\n\n\tion-title {\n\t\tpadding: 2px;\n\t\tfont-size: 20px;\n\t\tfont-weight: 500;\n\t\tcolor: var(--ion-color-primary);\n\t\tposition: relative;\n\t\ttop: 0;\n\t}\n\n\tion-icon.close-button {\n\t\tmargin: 2vw;\n\t\tposition: relative;\n\t\tborder: 1px solid;\n\t\tborder-radius: 10px;\n\t\theight: 5vw;\n\t\twidth: 8vw;\n\t\tcolor: var(--ion-color-primary);\n\t}\n}\n\n:host{\n\tbackground: var(--ion-ultra-grey);\n\t\t\t\t--background: var(--ion-ultra-grey);\n}\n\n\tion-card {\n\t\t//margin: 35px 12px 0;\n\t\tbox-shadow: none;\n\n\t\tion-label {\n\t\t\tfont-size: 20px;\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: row;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t}\n\n\t\tform {\n\t\t\tmargin: 16px;\n\n\t\t\tion-textarea {\n\t\t\t\t--padding-start: 10px;\n\t\t\t\tborder-radius: 15px;\n\t\t\t\tborder: 0px solid var(--ion-color-tertiary);\n\t\t\t\twidth: 100%;\n\t\t\t\tbox-shadow: var(--shadow-l1);\n\t\t\t\tbackground: var(--ion-ultra-grey);\n\t\t\t\t--background: var(--ion-ultra-grey);\n\t\t\t}\n\t\t\tion-card.upload {\n\tpadding: 10px;\n    margin: 10px 0;\n    border-radius: 15px;\n    border: 0px solid var(--ion-color-tertiary);\n    text-align: center;\n    box-shadow: var(--shadow-l);\n    width: 100%;\n\tbackground: var(--ion-ultra-grey);\n\t\t\t\t--background: var(--ion-ultra-grey);\n\n\t\t\t\tion-label {\n\t\t\t\t\tion-icon {\n\t\t\t\t\t\tfont-size: 35px;\n\t\t\t\t\t}\n\n\t\t\t\t\tp {\n\t\t\t\t\t\tfont-size: 15px;\n\t\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\t\tline-height: 23px;\n\t\t\t\t\t\tletter-spacing: 0em;\n\t\t\t\t\t\tcolor: var(--ion-color-primary);\n\t\t\t\t\t}\n\n\t\t\t\t\tsmall {\n\t\t\t\t\t\tfont-size: 9px;\n\t\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\t\tline-height: 18px;\n\t\t\t\t\t\tletter-spacing: 0em;\n\t\t\t\t\t\tcolor: var(--ion-white-primary);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\tion-button {\n\t\t\t\theight: 10vw;\n\t\t\t\t--border-radius: 12px;\n\t\t\t\twidth: 100%;\n\n\t\t\t\tfont-size: 18px;\n\t\t\t\tfont-weight: 700;\n\t\t\t\tline-height: 28px;\n\t\t\t\tletter-spacing: 0em;\n\t\t\t\ttext-align: left;\n\t\t\t\tmargin-top: 30px;\n\t\t\t\t--background: var(--ion-color-primary);\n\t\t\t\t--background-activated: var(--ion-color-primary);\n\t\t\t\t--background-focused: var(--ion-color-primary);\n\t\t\t\t--background-hover: var(--ion-color-primary);\n\t\t\t}\n\t\t}\n\t}\n\n.hideThis{\n\tvisibility: hidden;\n\tposition: fixed;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
